module.exports = __webpack_public_path__ + "static/img/1-2.cd2a846.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/1-2.png
// module id = +31q
// module chunks = 0